/**
 * Validate a post-login `redirect` target. Only same-origin absolute paths are
 * allowed — anything external, protocol-relative (`//evil.com`), or non-path is
 * rejected (returns null) so the `?redirect=` param can't be abused for an open
 * redirect.
 */
export function getSafeRedirect(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let decoded: string;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return null;
  }
  // Must be a root-relative path, and not protocol-relative ("//host").
  if (!decoded.startsWith('/') || decoded.startsWith('//')) return null;
  return decoded;
}
